import Image1 from "./images/Destruction.png";
import SiteData from "./helpers/data.json";
import CountryList from "./helpers/countriesList.json";

import { Carousel } from "./Carousel";
import "../App.css";

import { useTranslation } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import * as bootstrap from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import RUG from "react-upload-gallery";
import axios from "axios";
import "./ThankYou";
import "./Error";
import { getEnv } from "../components/helpers/Config";
import { Axios } from "../axios/Axios";
import Viewer from "react-viewer";
import { useMediaQuery } from "react-responsive";
import ReactGA from "react-ga";
import MaterialReactTable from "material-react-table";
import "react-upload-gallery/dist/style.css";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Home = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAvailable, setIsAvailable] = useState(false);
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const location = useLocation();
  const fieldRef = useRef(null);
  const [showPage, setShowPage] = useState(1);
  const [ip, setIp] = useState(null);
  const [ipCountry, setIPCountry] = useState(null);
  const languageDetector = new LanguageDetector();
  const lang = languageDetector.detect();

  const [className, setClassName] = useState("btn btn-primary btn-lg pt-1");
  const [images, setImages] = useState([]);
  const [images2, setImages2] = useState([]);

  const [imageValid, setImageValid] = useState(true);
  const [image2Valid, setImage2Valid] = useState(true);

  const [addressValid, setAddressValid] = useState(true);
  const [byPassCheck, setByPassCheck] = useState(false);
  const [qtyError, setQtyError] = useState(false);

  const [image1Visible, setImage1Visible] = useState(false);

  let navigate = useNavigate();
  const siteId = 64;
  let url = getEnv();
  const { t, i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    trigger,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
  });
  //This use effect checks to make sure the site is available then loads any data needed
  useEffect(() => {
    //creating function to load ip address from the API
    axios({
      method: "get",
      url: "https://geo.ipify.org/api/v2/country?apiKey=at_mZPV5WaJpM2bF7M1CUirKxtZZ7k5R",
    })
      .then((response) => {
        setIp(response.data.ip);
        setIPCountry(response.data.location.country);
        console.log(ip);
        axios({
          method: "get",
          url:
            url +
            "/verification/SiteAvailability?id=" +
            siteId +
            "&&ip=" +
            response.data.ip,
        })
          .then((response) => {
            if (!response.data) {
              navigate("/Construction", { replace: true });
            } else {
              document.getElementById("loading").classList.add("d-none");
              setIsAvailable(true);
              console.log(isMobile);
            }
          })
          .catch((response) => {
            navigate("/Error", { replace: true });
          });
      })
      .catch((response) => {
        console.log("IP address retrieval failure");
        navigate("/Construction", { replace: true });
      });
  }, []);
  //This useEffect is for google analytics
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  useEffect(() => {
    if (isMobile) {
      setClassName("btn btn-primary btn-lg pt-1 justify-content-center col-12");
    }
  }, [isMobile]);

  useEffect(() => {
    if (location.state?.data) {
      setShowPage(1);
      reset();
    }
  }, [location.key]);
  useEffect(() => {
    fieldRef.current.scrollIntoView({
      behavior: "smooth",
    });
  }, [showPage]);
  const onSubmit = async (data) => {
    clickHandleRecaptcha("RainbowRoadSubmit");
    // if (images.length > 0) {
    //   setImageValid(true);
    // } else {
    //   setImageValid(false);
    //   return;
    // }
    setIsSubmitting(true);
    const imagesArray = images.split(",");

    let SFDFI = [
      {
        DynamicFieldId: 33504,
        FieldValue: data.address,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33512,
        FieldValue: data.city,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33513,
        FieldValue: data.country,
        //FieldValue: "US",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33508,
        FieldValue: data.email,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33502,
        FieldValue: data.firstName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33503,
        FieldValue: data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33515,
        FieldValue: data.postalCode,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33507,
        FieldValue: data.phoneNumber,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67998,
        FieldValue: ip,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 68006,
        FieldValue: ipCountry,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33514,
        FieldValue: data.state,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 37611,
        FieldValue: "Refund",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      // Site Specific Fields

      {
        DynamicFieldId: 68203,
        FieldValue: imagesArray[1],
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 68222,
        FieldValue: data.code.toString(),
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 68223,
        FieldValue: data.signature,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 68204,
        FieldValue: data.region,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 68577,
        FieldValue: data.reCaptchaScore.toString(),
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
    ];

    if (watchRegion === "United States") {
      SFDFI.push({
        DynamicFieldId: 68205,
        FieldValue: "Mastercard",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (watchRegion === "Canada") {
      var sub = lang.substring(0, 2).toUpperCase();
      if (sub !== "EN" && sub !== "FR") {
        sub = "EN";
      }
      const dataOptions = SiteData.filter(
        (c) => c.parentBrandName === getValues("giftCard") && c.locale === sub
      ).map((c) => c.contentProviderCode);
      console.log(dataOptions);
      SFDFI.push({
        DynamicFieldId: 68205,
        FieldValue: dataOptions[0],
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (watchRegion === "United Kingdom") {
      SFDFI.push({
        DynamicFieldId: 68205,
        FieldValue: "MBI",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.abc && data.abc !== "") {
      SFDFI.push({
        DynamicFieldId: 68226,
        FieldValue: data.abc,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.animalCounting && data.animalCounting !== "") {
      SFDFI.push({
        DynamicFieldId: 68206,
        FieldValue: data.animalCounting,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.dinosaur && data.dinosaur !== "") {
      SFDFI.push({
        DynamicFieldId: 68208,
        FieldValue: data.dinosaur,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.macDonald && data.macDonald !== "") {
      SFDFI.push({
        DynamicFieldId: 68210,
        FieldValue: data.macDonald,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.rainbow && data.rainbow !== "") {
      SFDFI.push({
        DynamicFieldId: 68212,
        FieldValue: data.rainbow,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.oldLady && data.oldLady !== "") {
      SFDFI.push({
        DynamicFieldId: 68214,
        FieldValue: data.oldLady,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.thingsThatGo && data.thingsThatGo !== "") {
      SFDFI.push({
        DynamicFieldId: 68216,
        FieldValue: data.thingsThatGo,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.unicorn && data.unicorn !== "") {
      SFDFI.push({
        DynamicFieldId: 68218,
        FieldValue: data.unicorn,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.bottom && data.bottom !== "") {
      SFDFI.push({
        DynamicFieldId: 68220,
        FieldValue: data.bottom,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.address2) {
      SFDFI.push({
        DynamicFieldId: 33506,
        FieldValue: data.address2,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.confirm === "No") {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.attentionTo,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    } else {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.firstName + " " + data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    console.log(data);

    var SimpleSuperFormDTO = {
      FormInstances: {
        DefinitionId: 537,
        CompanyId: 112,
        CreatedBy: 803,
        CreatedFor: 803,
        WorkTypeItemId: 3744,
        WorkFlowOverallStatusId: 1,
        WorkflowId: 1,
        Source: 3,
        InstanceID: 0,
      },
      DynamicFieldslist: SFDFI,
    };
    SimpleSuperFormDTO.FormInstances.CreatedDate = new Date();
    console.log(SimpleSuperFormDTO);
    axios({
      method: "post",
      url: url + "/SuperForm/SaveSimpleSuperForm",
      data: SimpleSuperFormDTO,
    })
      .then((response) => {
        console.log("success");
        Axios.email(data, response.data.formInstances.instanceId);
        navigate("/ThankYou", {
          state: {
            id: response.data.formInstances.instanceId,
            region: data.region,
          },
          replace: true,
        });
      })
      .catch((response) => {
        console.log("fail");
        navigate("/Error", { replace: true });
      });
  };
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [token, setToken] = useState("");
  const [noOfVerifications, setNoOfVerifications] = useState(0);

  const clickHandleRecaptcha = useCallback(
    async (action) => {
      if (!executeRecaptcha) {
        return;
      }

      const result = await executeRecaptcha(action);

      setToken(result);
      setNoOfVerifications((noOfVerifications) => noOfVerifications + 1);
      let verifyToken = await Axios.verifyReCAPTCHA(result);
      if (verifyToken) {
        setValue("reCaptchaScore", verifyToken.data.score);
      }
    },
    [executeRecaptcha]
  );

  console.log(errors);
  const watchConfirm = watch("confirm", null); // you can supply default value as second argument
  const watchCountry = watch("country", null); // you can supply default value as second argument
  const watchRegion = watch("region", null);
  return (
    <div className="field" ref={fieldRef}>
      <bootstrap.Form onSubmit={handleSubmit(onSubmit)}>
        <bootstrap.Container fluid>
          <div className="spinner-grow text-primary" id="loading"></div>
          {isAvailable && (
            <div>
              {/* Start step 1 */}
              {showPage === 1 && (
                <div className="setup-content" id="step1">
                  {/* Hidden fields on the form */}
                  <bootstrap.Form.Text
                    type="text"
                    className="text-center lead d-none"
                    id="reCaptchaScore"
                    disabled
                    {...register("reCaptchaScore")}
                  />
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-1">{t("step1.header1")}</h2>
                      <p className="lead py-1">{t("step1.textA")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>

                  <Carousel />
                  <bootstrap.Row>
                    {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                    <bootstrap.Col className="form-group align-content-lg-center">
                      <p className="lead py-1">{t("step1.textB")}</p>
                      {/* Region */}
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Select
                          size="lg"
                          className="text-center"
                          //aria-label="Default select example"
                          id="region"
                          {...register("region", { required: true })}
                        >
                          <option value="">{t("layout.pleaseSelect")}</option>
                          {CountryList.map((c) => (
                            <option value={c.Country}>{c.Country}</option>
                          ))}
                        </bootstrap.Form.Select>
                      </bootstrap.InputGroup>
                      {errors.region && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                    {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                  </bootstrap.Row>
                  {watchRegion !== "" && watchRegion && (
                    <bootstrap.Row>
                      <bootstrap.Col>
                        {(watchRegion === "United States" ||
                          watchRegion === "Canada") && (
                          <p className="lead py-1">{t("step1.text")}</p>
                        )}
                        <p className="lead py-1">{t("step1.textD")}</p>
                        <bootstrap.Row>
                          {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                          <bootstrap.Col className="form-group align-content-lg-center">
                            <bootstrap.Table
                              bordered
                              striped
                              hover
                              responsive="sm"
                            >
                              <thead>
                                <tr>
                                  <th>{t("step1.table1")}</th>
                                  <th>{t("step1.table2")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(watchRegion === "Australia" ||
                                  watchRegion === "New Zealand") && (
                                  <tr>
                                    {/* ABC */}
                                    <td>{t("step1.table1A")}</td>
                                    <td>{t("step1.table2A1")}</td>
                                  </tr>
                                )}

                                {/* Animal Counting */}
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1B")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2B1")}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1B1")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2B2")}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1B2")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2B3")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2B4")}
                                  </td>
                                </tr>
                                {/* Dinosaur */}
                                <tr>
                                  <td>{t("step1.table1C")}</td>
                                  <td>{t("step1.table2C1")}</td>
                                </tr>
                                <tr>
                                  <td>{t("step1.table1C1")}</td>
                                  <td>{t("step1.table2C2")}</td>
                                </tr>
                                <tr>
                                  <td>{t("step1.table1C2")}</td>
                                  <td>{t("step1.table2C3")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2C4")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2C5")}</td>
                                </tr>
                                {/* MacDonald */}
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1D")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2D1")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2D2")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2D3")}
                                  </td>
                                </tr>
                                {/* Rainbow */}
                                <tr>
                                  <td>{t("step1.table1E")}</td>
                                  <td>{t("step1.table2E1")}</td>
                                </tr>
                                {/* Old Lady */}
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1F")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2F1")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2F2")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2F3")}
                                  </td>
                                </tr>
                                {/* Things That Go */}
                                <tr>
                                  <td>{t("step1.table1G")}</td>
                                  <td>{t("step1.table2G1")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2G2")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2G3")}</td>
                                </tr>
                                {/* Unicorn */}
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1H")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2H1")}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1H1")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2H2")}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1H2")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2H3")}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-primary">
                                    {t("step1.table1H3")}
                                  </td>
                                  <td className="text-primary">
                                    {t("step1.table2H4")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2H5")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2H6")}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className="text-primary">
                                    {t("step1.table2H7")}
                                  </td>
                                </tr>
                                {/* Bottom */}
                                <tr>
                                  <td>{t("step1.table1I")}</td>
                                  <td>{t("step1.table2I1")}</td>
                                </tr>
                                <tr>
                                  <td>{t("step1.table1I1")}</td>
                                  <td>{t("step1.table2I2")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2I3")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2I4")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2I5")}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>{t("step1.table2I6")}</td>
                                </tr>
                              </tbody>
                            </bootstrap.Table>
                          </bootstrap.Col>
                          {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                        </bootstrap.Row>
                        <p className="lead py-1">{t("step1.textE")}</p>
                        <p className="lead py-1">{t("step1.textF")}</p>
                        <ol>
                          <li className="lead py-1">{t("step1.textF1")}</li>
                          <li className="lead py-1">{t("step1.textF2")}</li>
                          {watchRegion !== "Cyprus" && (
                            <li className="lead py-1">{t("step1.textF3")}</li>
                          )}
                          {watchRegion === "Cyprus" && (
                            <li className="lead py-1">{t("step1.textF4")}</li>
                          )}
                        </ol>
                        {(watchRegion === "Armenia" ||
                          watchRegion === "Bermuda" ||
                          watchRegion === "Brunei" ||
                          watchRegion === "Costa Rica" ||
                          watchRegion === "Ecuador" ||
                          watchRegion === "Guatemala" ||
                          watchRegion === "Honduras" ||
                          watchRegion === "Jordan" ||
                          watchRegion === "Kyrgyzstan" ||
                          watchRegion === "Maldives" ||
                          watchRegion === "Mongolia" ||
                          watchRegion === "Panama" ||
                          watchRegion === "Seychelles" ||
                          watchRegion === "St. Maarten") && (
                          <p className="lead py-1">{t("step1.textG1")}</p>
                        )}

                        {watchRegion === "Cyprus" && (
                          <p className="lead py-1">{t("step1.textG2")}</p>
                        )}
                        {watchRegion !== "Armenia" &&
                          watchRegion !== "Bermuda" &&
                          watchRegion !== "Brunei" &&
                          watchRegion !== "Costa Rica" &&
                          watchRegion !== "Ecuador" &&
                          watchRegion !== "Guatemala" &&
                          watchRegion !== "Honduras" &&
                          watchRegion !== "Jordan" &&
                          watchRegion !== "Kyrgyzstan" &&
                          watchRegion !== "Maldives" &&
                          watchRegion !== "Mongolia" &&
                          watchRegion !== "Panama" &&
                          watchRegion !== "Seychelles" &&
                          watchRegion !== "St. Maarten" &&
                          watchRegion !== "Cyprus" && (
                            <p className="lead py-1">{t("step1.textG")}</p>
                          )}
                        <p className="lead py-1">{t("step1.textH")}</p>
                      </bootstrap.Col>
                    </bootstrap.Row>
                  )}

                  <bootstrap.Row className="text-center col align-content-lg-center pt-2 pb-1">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className={className}
                        //className="btn btn-primary btn-lg pt-1 justify-content-center"
                        type="button"
                        onClick={async () => {
                          clickHandleRecaptcha("RainbowRoadregister");
                          const result = await trigger(["region"]);
                          if (result) {
                            if (watchRegion === "Canada") {
                              setShowPage(2);
                            } else {
                              setShowPage(3);
                            }
                          }
                        }}
                        id="step1Button"
                      >
                        {t("buttons.getStarted")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 2 */}
              {showPage === 2 && (
                <div className="setup-content" id="step2">
                  <bootstrap.Container className="py-2">
                    <bootstrap.Card className="border-custom">
                      <bootstrap.Card.Body>
                        <bootstrap.Row>
                          <bootstrap.Col>
                            <p className="lead py-1">{t("step2.2A")}</p>
                          </bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row>
                          {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                          <bootstrap.Col className="form-group align-content-lg-center">
                            {/* gift card choice*/}
                            <bootstrap.InputGroup className="mb-3">
                              <bootstrap.Form.Select
                                size="lg"
                                className="text-center"
                                //aria-label="Default select example"
                                id="giftCard"
                                {...register("giftCard", { required: true })}
                              >
                                <option value="">
                                  {t("layout.pleaseSelect")}
                                </option>
                                <option value="Amazon.ca">Amazon.ca</option>
                                <option value="CINEPLEX">CINEPLEX</option>
                                <option value="Indigo">Indigo</option>
                                <option value="Jack Astor's">
                                  Jack Astor's
                                </option>
                                <option value="Kernels Popcorn">
                                  Kernels Popcorn
                                </option>
                                <option value="Red Lobster">Red Lobster</option>
                                <option value="Red Robin Gourmet Burgers and Brews">
                                  Red Robin Gourmet Burgers and Brews
                                </option>
                                <option value="REDS">REDS</option>
                                <option value="Scaddabush Italian Kitchen & Bar">
                                  Scaddabush Italian Kitchen & Bar
                                </option>
                                <option value="Service Inspired Restaurants">
                                  Service Inspired Restaurants
                                </option>
                              </bootstrap.Form.Select>
                            </bootstrap.InputGroup>
                            {errors.giftCard && (
                              <bootstrap.Alert variant="danger">
                                <p className="lead text-danger text-center">
                                  {t("errors.required")}
                                </p>
                              </bootstrap.Alert>
                            )}
                          </bootstrap.Col>
                          {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                        </bootstrap.Row>
                      </bootstrap.Card.Body>
                    </bootstrap.Card>
                    <bootstrap.Row className="text-center col align-content-lg-center pt-2 pb-1">
                      <bootstrap.Col>
                        <bootstrap.Button
                          className={className}
                          //className="btn btn-primary btn-lg pt-1 justify-content-center"
                          type="button"
                          onClick={async () => {
                            clickHandleRecaptcha("RainbowRoadGiftCard");
                            const result = await trigger(["giftCard"]);
                            if (result) {
                              setShowPage(3);
                            }
                          }}
                          id="step2Button"
                        >
                          {t("buttons.next")}
                        </bootstrap.Button>
                      </bootstrap.Col>
                    </bootstrap.Row>
                  </bootstrap.Container>
                </div>
              )}
              {/* Start step 3 */}
              {showPage === 3 && (
                <div className="setup-content" id="step2">
                  {/* Gather Contact Information */}
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead py-2">{t("contactStep.textA")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <bootstrap.Card className="border-custom">
                        <bootstrap.Card.Body>
                          <bootstrap.Row>
                            {!isMobile && (
                              <bootstrap.Col lg={2}></bootstrap.Col>
                            )}
                            <bootstrap.Col className="form-group align-content-lg-center">
                              {/* First Name */}
                              <bootstrap.Form.Label
                                htmlFor="firstName"
                                className="lead"
                              >
                                {t("contactStep.firstName")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  // placeholder={t("contactStep.firstName")}
                                  id="firstName"
                                  {...register("firstName", {
                                    required: true,
                                    maxLength: 80,
                                  })}
                                />{" "}
                              </bootstrap.InputGroup>
                              {errors.firstName && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Last Name */}
                              <bootstrap.Form.Label
                                htmlFor="lastName"
                                className="lead"
                              >
                                {t("contactStep.lastName")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder={t("contactStep.lastName")}
                                  id="lastName"
                                  {...register("lastName", {
                                    required: true,
                                    maxLength: 100,
                                  })}
                                />
                              </bootstrap.InputGroup>
                              {errors.lastName && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Email */}
                              <bootstrap.Form.Label
                                htmlFor="email"
                                className="lead"
                              >
                                {t("contactStep.email")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="email"
                                  //placeholder={t("contactStep.email")}
                                  id="email"
                                  aria-describedby="emailtext"
                                  {...register("email", {
                                    required: true,
                                    pattern:
                                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                  })}
                                />

                                <bootstrap.InputGroup.Text id="emailText">
                                  @example.com
                                </bootstrap.InputGroup.Text>
                              </bootstrap.InputGroup>
                              {errors.email && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {errors.email &&
                                errors.email.type === "pattern" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.emailFormatError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                              {/* Verify Email */}
                              <bootstrap.Form.Label
                                htmlFor="verifyEmail"
                                className="lead"
                              >
                                {t("contactStep.verifyEmail")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="email"
                                  //placeholder={t("contactStep.verifyEmail")}
                                  id="verifyEmail"
                                  aria-describedby="verifyEmailText"
                                  {...register("verifyEmail", {
                                    required: true,
                                    pattern:
                                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    validate: {
                                      mismatch: (value) => {
                                        const { email } = getValues();
                                        return email === value;
                                      },
                                    },
                                  })}
                                />
                                <bootstrap.InputGroup.Text id="verifyEmailText">
                                  @example.com
                                </bootstrap.InputGroup.Text>
                              </bootstrap.InputGroup>
                              {errors.verifyEmail &&
                                errors.verifyEmail.type === "mismatch" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.emailMismatchError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                              {errors.verifyEmail &&
                                errors.verifyEmail.type === "pattern" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.emailFormatError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                              {errors.verifyEmail && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Phone */}
                              <bootstrap.Form.Label
                                htmlFor="phone"
                                className="lead"
                              >
                                {t("contactStep.phone")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="tel"
                                  placeholder="XXXXXXXXXX"
                                  id="phone"
                                  {...register("phoneNumber", {
                                    required: true,
                                    minLength: 10,
                                    maxLength: 20,
                                    // pattern:
                                    //   /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i,
                                  })}
                                />
                              </bootstrap.InputGroup>
                              {errors.phoneNumber && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {errors.phoneNumber &&
                                errors.phoneNumber.type === "pattern" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.phoneFormatError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                            </bootstrap.Col>
                            {!isMobile && (
                              <bootstrap.Col lg={2}></bootstrap.Col>
                            )}
                          </bootstrap.Row>
                          <bootstrap.Row>
                            {!isMobile && (
                              <bootstrap.Col lg={2}></bootstrap.Col>
                            )}
                            <bootstrap.Col className="py-1">
                              <p className="text-center lead font-weight-bold">
                                {t("contactStep.confirm")}
                              </p>

                              {/* Contact Confirm */}
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Select
                                  className="text-center"
                                  aria-label="Default select example"
                                  id="confirm"
                                  {...register("confirm", { required: true })}
                                >
                                  <option value="">
                                    {t("layout.pleaseSelect")}
                                  </option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </bootstrap.Form.Select>
                              </bootstrap.InputGroup>
                              {errors.confirm && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Attention To*/}
                              {watchConfirm === "No" && (
                                <div>
                                  <bootstrap.Form.Label
                                    htmlFor="attentionTo"
                                    className="lead"
                                  >
                                    {t("contactStep.attentionTo")}
                                  </bootstrap.Form.Label>
                                  <bootstrap.InputGroup className="mb-3">
                                    <bootstrap.Form.Control
                                      type="text"
                                      // placeholder={t("contactStep.firstName")}
                                      id="attentionTo"
                                      {...register("attentionTo", {
                                        maxLength: 80,
                                        validate: {
                                          required: (value) =>
                                            watchConfirm === "No" &&
                                            value.length > 0,
                                        },
                                      })}
                                    />
                                  </bootstrap.InputGroup>
                                  {errors.attentionTo && (
                                    <bootstrap.Alert variant="danger">
                                      <p className="lead text-danger text-center">
                                        {t("errors.required")}
                                      </p>
                                    </bootstrap.Alert>
                                  )}
                                </div>
                              )}
                            </bootstrap.Col>
                            {!isMobile && (
                              <bootstrap.Col lg={2}></bootstrap.Col>
                            )}
                          </bootstrap.Row>
                        </bootstrap.Card.Body>
                      </bootstrap.Card>
                      <bootstrap.Row className="text-center col align-content-lg-center pt-2 pb-1">
                        <bootstrap.Col>
                          <bootstrap.Button
                            className={className}
                            type="button"
                            onClick={async () => {
                              clickHandleRecaptcha("RainbowRoadContactInfo");
                              let result;
                              result = await trigger([
                                "firstName",
                                "lastName",
                                "email",
                                "verifyEmail",
                                "phoneNumber",
                                "confirm",
                                "attentionTo",
                              ]);
                              if (result) {
                                setShowPage(4);
                              }
                            }}
                            id="step3Button"
                          >
                            {t("buttons.next")}
                          </bootstrap.Button>
                        </bootstrap.Col>
                      </bootstrap.Row>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 4 */}
              {showPage === 4 && (
                <div className="setup-content" id="step4">
                  {/* Gather Contact Information */}
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-5">{t("addressStep.header")}</h2>
                      <p className="lead py-2">{t("addressStep.subHeader")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <bootstrap.Card className="border-custom">
                        <bootstrap.Card.Body>
                          <bootstrap.Row>
                            {!isMobile && (
                              <bootstrap.Col lg={2}></bootstrap.Col>
                            )}
                            <bootstrap.Col className="form-group align-content-lg-center">
                              {/* Adress Line 1 */}
                              <bootstrap.Form.Label
                                htmlFor="address"
                                className="lead"
                              >
                                {t("addressStep.address1")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  id="address"
                                  {...register("address", { required: true })}
                                />
                              </bootstrap.InputGroup>
                              {errors.address && (
                                <bootstrap.Alert className="" variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Address 2 */}
                              <bootstrap.Form.Label
                                htmlFor="address2"
                                className="lead"
                              >
                                {t("addressStep.address2")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder={t("contactStep.lastName")}
                                  id="address2"
                                  {...register("address2", {})}
                                />
                              </bootstrap.InputGroup>
                              {errors.address2 && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* City */}
                              <bootstrap.Form.Label
                                htmlFor="city"
                                className="lead"
                              >
                                {t("addressStep.city")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder={t("contactStep.email")}
                                  id="city"
                                  {...register("city", { required: true })}
                                />
                              </bootstrap.InputGroup>
                              {errors.city && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Country */}
                              <bootstrap.Form.Label
                                htmlFor="country"
                                className="lead"
                              >
                                {t("addressStep.country")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Select
                                  size="lg"
                                  className="text-center"
                                  //aria-label="Default select example"
                                  id="country"
                                  {...register("country", { required: true })}
                                >
                                  <option value="">
                                    {t("layout.pleaseSelect")}
                                  </option>
                                  {CountryList.map((c) => (
                                    <option value={c.Country}>
                                      {c.Country}
                                    </option>
                                  ))}
                                </bootstrap.Form.Select>
                              </bootstrap.InputGroup>
                              {errors.country && (
                                <bootstrap.Alert className="" variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* State */}
                              <bootstrap.Form.Label
                                htmlFor="state"
                                className="lead"
                              >
                                {t("addressStep.state")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  id="state"
                                  {...register("state", { required: true })}
                                />
                              </bootstrap.InputGroup>
                              {errors.state && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Postal */}
                              <bootstrap.Form.Label
                                htmlFor="postal"
                                className="lead"
                              >
                                {t("addressStep.postalCode")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder="XXXXXXXXXX"
                                  id="postal"
                                  {...register("postalCode", {
                                    required: true,
                                    min: 5,
                                    // pattern:
                                    //   /\d{5}(-\d{4})?/i |
                                    //   /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
                                  })}
                                />
                              </bootstrap.InputGroup>
                              {errors.postalCode && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                            </bootstrap.Col>
                            {!isMobile && (
                              <bootstrap.Col lg={2}></bootstrap.Col>
                            )}
                          </bootstrap.Row>
                        </bootstrap.Card.Body>
                      </bootstrap.Card>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="text-center col align-content-lg-center pt-2 pb-1">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className={className}
                        type="button"
                        id="page4Button"
                        onClick={async () => {
                          clickHandleRecaptcha("RainbowRoadVerifyAddress");
                          const result = await trigger([
                            "address",
                            "city",
                            "country",
                            "state",
                            "postalCode",
                          ]);
                          if (result) {
                            setShowPage(5);
                          }
                        }}
                      >
                        {t("buttons.next")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 5 */}
              {showPage === 5 && (
                <div className="setup-content" id="step5">
                  <bootstrap.Container className="py-2">
                    <bootstrap.Card className="border-custom">
                      <bootstrap.Card.Body>
                        <bootstrap.Row>
                          <bootstrap.Col>
                            <p className="lead py-1">{t("step5.5A")}</p>
                          </bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row>
                          {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                          <bootstrap.Col className="form-group align-content-lg-center">
                            <bootstrap.Table striped bordered hover>
                              <thead>
                                <tr>
                                  <th>{t("step5.table1")}</th>
                                  <th>{t("step5.table2")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(watchRegion === "Australia" ||
                                  watchRegion === "New Zealand") && (
                                  <tr>
                                    {/* ABC */}
                                    <td>{t("step5.table1A")}</td>
                                    <td>
                                      <bootstrap.InputGroup className="mb-3">
                                        <bootstrap.Form.Select
                                          size="md"
                                          className="text-center"
                                          //aria-label="Default select example"
                                          id="abc"
                                          {...register("abc", {})}
                                        >
                                          <option value="">0</option>
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                          <option value="3">3</option>
                                        </bootstrap.Form.Select>
                                      </bootstrap.InputGroup>
                                    </td>
                                  </tr>
                                )}
                                {/* Animal Counting */}
                                <tr>
                                  <td>{t("step5.table1B")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="animalCounting"
                                        {...register("animalCounting", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* Dinosaur */}
                                <tr>
                                  <td>{t("step5.table1C")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="dinosaur"
                                        {...register("dinosaur", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* MacDonald */}
                                <tr>
                                  <td>{t("step5.table1D")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="macDonald"
                                        {...register("macDonald", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* Rainbow */}
                                <tr>
                                  <td>{t("step5.table1E")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="rainbow"
                                        {...register("rainbow", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* Old Lady */}
                                <tr>
                                  <td>{t("step5.table1F")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="oldLady"
                                        {...register("oldLady", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* Things That Go */}
                                <tr>
                                  <td>{t("step5.table1G")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="thingsThatGo"
                                        {...register("thingsThatGo", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* Unicorn */}
                                <tr>
                                  <td>{t("step5.table1H")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="unicorn"
                                        {...register("unicorn", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                                {/* Bottom */}
                                <tr>
                                  <td>{t("step5.table1I")}</td>
                                  <td>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="md"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="bottom"
                                        {...register("bottom", {})}
                                      >
                                        <option value="">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                  </td>
                                </tr>
                              </tbody>
                            </bootstrap.Table>
                          </bootstrap.Col>
                          {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                        </bootstrap.Row>
                        <bootstrap.Row>
                          <bootstrap.Col>
                            <p className="lead fw-italics py-1">
                              {t("step5.5B")}
                            </p>
                            {qtyError && (
                              <bootstrap.Alert variant="danger">
                                <p className="lead text-danger text-center">
                                  {t("errors.required")}
                                </p>
                              </bootstrap.Alert>
                            )}
                          </bootstrap.Col>
                        </bootstrap.Row>
                      </bootstrap.Card.Body>
                    </bootstrap.Card>
                    <bootstrap.Row className="text-center col align-content-lg-center pt-2 pb-1">
                      <bootstrap.Col>
                        <bootstrap.Button
                          className={className}
                          type="button"
                          onClick={async () => {
                            clickHandleRecaptcha("RainbowRoadQty");
                            const result = getValues([
                              "abc",
                              "animalCounting",
                              "dinosaur",
                              "macDonald",
                              "rainbow",
                              "oldLady",
                              "thingsThatGo",
                              "unicorn",
                              "bottom",
                            ]);
                            var blank = 0;
                            for (var i = 0; i < result.length; i++) {
                              if (result[i] !== "" && result[i] !== undefined) {
                                setValue(
                                  "code",
                                  Math.floor(10000 + Math.random() * 90000)
                                );
                                setQtyError(false);
                                setShowPage(6);
                              } else {
                                blank++;
                              }
                            }
                            if (blank === result.length) {
                              setQtyError(true);
                            }
                          }}
                          id="step5Button"
                        >
                          {t("buttons.next")}
                        </bootstrap.Button>
                      </bootstrap.Col>
                    </bootstrap.Row>
                  </bootstrap.Container>
                </div>
              )}
              {/* Start step 6 */}
              {showPage === 6 && (
                <div className="setup-content" id="step6">
                  <bootstrap.Row>
                    {!isMobile && <bootstrap.Col></bootstrap.Col>}
                    <bootstrap.Col>
                      {/* Destruction code*/}
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Label
                          htmlFor="code"
                          className="lead pe-3"
                        >
                          {t("step6.header")}
                        </bootstrap.Form.Label>
                        <bootstrap.Form.Control
                          type="text"
                          id="code"
                          disabled={true}
                          {...register("code", { required: true })}
                        />
                      </bootstrap.InputGroup>
                    </bootstrap.Col>
                    {!isMobile && <bootstrap.Col></bootstrap.Col>}
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead py-1">{t("step6.6A")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="align-items-end">
                    {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                    <bootstrap.Col>
                      {/* <p className="lead text-center">{t("step4.4C")}</p> */}
                      <bootstrap.Image
                        className="images img-fluid pb-4"
                        src={Image1}
                        onClick={() => {
                          setImage1Visible(true);
                        }}
                        id="image1"
                        alt="Destruction"
                      />
                      <Viewer
                        visible={image1Visible}
                        onClose={() => {
                          setImage1Visible(false);
                        }}
                        id="image1Viewer"
                        images={[{ src: Image1, alt: "Destruction" }]}
                      ></Viewer>
                    </bootstrap.Col>
                    {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                  </bootstrap.Row>

                  {/* Photo Upload */}
                  <bootstrap.Row className="pt-5">
                    {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                    <bootstrap.Col className="py-1">
                      <RUG
                        rules={{
                          limit: 1,
                          size: 5000,
                        }}
                        accept={["jpg", "jpeg", "png", "gif"]}
                        onWarning={(type, rules) => {
                          switch (type) {
                            case "accept":
                              return window.confirm(
                                `Invalid file type. Acceptable photo formats include ${rules.accept.join(
                                  ","
                                )}`
                              );
                            case "limit":
                              return window.confirm(
                                `Only ${rules.limit} image allowed to be uploaded`
                              );

                            case "size":
                              return window.confirm(
                                `max size <= ${rules.size} KB`
                              );

                            default:
                          }
                        }}
                        onChange={(images) => {
                          if (images.length === 0) {
                            setImages(images);
                          }
                        }}
                        customRequest={({
                          uid,
                          file,
                          data, // blob
                          send,
                          action,
                          headers,
                          onProgress,
                          onSuccess,
                          onError,
                        }) => {
                          if (file) {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = (e) => {
                              setImages(reader.result);
                            };
                            setImageValid(true);
                          } else {
                            setImageValid(false);
                          }
                          return {
                            abort() {
                              // for cancels the request
                            },
                          };
                        }}
                      />
                      {!imageValid && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                    {!isMobile && <bootstrap.Col lg={2}></bootstrap.Col>}
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead pt-4 pb-1">{t("step6.6B")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>

                  <bootstrap.Row className="text-center col align-content-lg-center pt-2 pb-1">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className={className}
                        type="button"
                        onClick={() => {
                          clickHandleRecaptcha("RainbowRoadDestruction");
                          if (images.length > 0) {
                            setImageValid(true);
                            setShowPage(7);
                          } else {
                            setImageValid(false);
                          }
                        }}
                        id="step6Button"
                      >
                        {t("buttons.next")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 7 */}
              {showPage === 7 && (
                <div className="setup-content" id="step7">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead py-1">{t("step7.7A")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      {/* Check 1*/}
                      <bootstrap.InputGroup className="py-1">
                        <bootstrap.Form.Check type="checkbox" inline>
                          <bootstrap.Form.Check.Input
                            type="checkbox"
                            id="check1"
                            {...register("check1", { required: true })}
                          />
                        </bootstrap.Form.Check>
                        <bootstrap.Form.Check.Label className="lead">
                          {t("step7.7B")}
                        </bootstrap.Form.Check.Label>
                      </bootstrap.InputGroup>

                      {errors.check1 && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      {/* Check 2*/}
                      <bootstrap.InputGroup className="py-1">
                        <bootstrap.Form.Check type="checkbox" inline>
                          <bootstrap.Form.Check.Input
                            type="checkbox"
                            id="check2"
                            {...register("check2", { required: true })}
                          />
                        </bootstrap.Form.Check>
                        <bootstrap.Form.Check.Label className="lead">
                          {t("step7.7C")}
                        </bootstrap.Form.Check.Label>
                      </bootstrap.InputGroup>

                      {errors.check2 && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      {/* Check 3*/}
                      <bootstrap.InputGroup className="py-1">
                        <bootstrap.Form.Check type="checkbox" inline>
                          <bootstrap.Form.Check.Input
                            type="checkbox"
                            id="check3"
                            {...register("check3", { required: true })}
                          />
                        </bootstrap.Form.Check>
                        <bootstrap.Form.Check.Label className="lead">
                          {t("step7.7D")}
                        </bootstrap.Form.Check.Label>
                      </bootstrap.InputGroup>

                      {errors.check3 && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      {/* Check 4*/}
                      <bootstrap.InputGroup className="py-1">
                        <bootstrap.Form.Check type="checkbox" inline>
                          <bootstrap.Form.Check.Input
                            type="checkbox"
                            id="check4"
                            {...register("check4", { required: true })}
                          />
                        </bootstrap.Form.Check>
                        {(watchRegion === "Armenia" ||
                          watchRegion === "Bermuda" ||
                          watchRegion === "Brunei" ||
                          watchRegion === "Costa Rica" ||
                          watchRegion === "Ecuador" ||
                          watchRegion === "Guatemala" ||
                          watchRegion === "Honduras" ||
                          watchRegion === "Jordan" ||
                          watchRegion === "Kyrgyzstan" ||
                          watchRegion === "Maldives" ||
                          watchRegion === "Mongolia" ||
                          watchRegion === "Panama" ||
                          watchRegion === "Seychelles" ||
                          watchRegion === "St. Maarten") && (
                          <bootstrap.Form.Check.Label className="lead">
                            {t("step7.7E1")}
                          </bootstrap.Form.Check.Label>
                        )}

                        {watchRegion === "Cyprus" && (
                          <bootstrap.Form.Check.Label className="lead">
                            {t("step7.7E2")}
                          </bootstrap.Form.Check.Label>
                        )}
                        {watchRegion !== "Armenia" &&
                          watchRegion !== "Bermuda" &&
                          watchRegion !== "Brunei" &&
                          watchRegion !== "Costa Rica" &&
                          watchRegion !== "Ecuador" &&
                          watchRegion !== "Guatemala" &&
                          watchRegion !== "Honduras" &&
                          watchRegion !== "Jordan" &&
                          watchRegion !== "Kyrgyzstan" &&
                          watchRegion !== "Maldives" &&
                          watchRegion !== "Mongolia" &&
                          watchRegion !== "Panama" &&
                          watchRegion !== "Seychelles" &&
                          watchRegion !== "St. Maarten" &&
                          watchRegion !== "Cyprus" && (
                            <bootstrap.Form.Check.Label className="lead">
                              {t("step7.7E")}
                            </bootstrap.Form.Check.Label>
                          )}
                      </bootstrap.InputGroup>

                      {errors.check4 && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead pt-4">{t("step7.7F")}</p>
                      <p className="lead">
                        {t("step7.7G1")}
                        <input
                          type="text"
                          className="signature titleLine ps-3"
                          id="signature"
                          {...register("signature", { required: true })}
                        />
                        {t("step7.7G2")}
                      </p>
                      {errors.signature && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="pt-2">
                    {!isSubmitting && (
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1 justify-content-center"
                        type="submit"
                        id="SubmitButton"
                      >
                        {t("buttons.submit")}
                      </bootstrap.Button>
                    )}
                    {isSubmitting && (
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1 justify-content-center"
                        variant="primary"
                        disabled
                      >
                        <bootstrap.Spinner
                          as="span"
                          animation="border"
                          variant="status"
                          aria-hidden="true"
                        ></bootstrap.Spinner>
                      </bootstrap.Button>
                    )}
                  </bootstrap.Row>
                </div>
              )}
            </div>
          )}
        </bootstrap.Container>
      </bootstrap.Form>
    </div>
  );
};
